@if (displaySrc(); as src) {
  <img
    class="lt-resolved-image__img"
    [class.lt-resolved-image__img--fill]="fill()"
    [class.lt-resolved-image__img--focus-top]="isTopFocused()"
    [style.object-fit]="fit()"
    [src]="src"
    [attr.srcset]="displaySrcset()"
    [alt]="displayAlt()"
    [attr.data-testid]="testId()"
    [attr.loading]="loading()"
    decoding="async"
    (error)="onError()"
  />
}
